export default "/images/trigger.svg?b408f4e6b42119a7bfa7f23d9a6be376";